import * as React from "react";
const SvgPercent = (props) => /* @__PURE__ */ React.createElement("svg", { width: 60, height: 60, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("text", { x: "50%", y: "50%", textAnchor: "middle", dominantBaseline: "middle", fontSize: 25, fontFamily: "Montserrat", fill: "black" }, "%"));
export default SvgPercent;
